import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	placeholder: {
		id: 'portfolio-3-portfolio.app-simple-plans.top.title-bar.title.placeholder',
		defaultMessage: 'Untitled plan',
		description: 'Placeholder for untitled plan title',
	},
	planTitle: {
		id: 'portfolio-3-portfolio.app-simple-plans.top.title-bar.title.plan-title',
		defaultMessage: 'Plan title',
		description: 'Label for the plan title',
	},
	tooLongInputErrorMessage: {
		id: 'portfolio-3-portfolio.app-simple-plans.top.title-bar.title.too-long-input-error-message',
		defaultMessage: 'Title cannot be longer than 255 characters',
		description: 'Message to show when user tries to enter a title that is too long',
	},
	plans: {
		id: 'portfolio-3-portfolio.app-simple-plans.top.title-bar.title.plans',
		defaultMessage: 'Plans',
		description: 'Document title for the feature plans',
	},
});
